import { useState, useEffect } from 'react'

import Image, { StaticImageData } from 'next/image'

import AssetMissingNonprod from '@/assets/images/asset-missing-nonprod.png'
import NotFound from '@/assets/images/bag.png'

import { config } from '../../../../../config'

const STAGE = config.STAGE

export const AnimatedImageWithFallback = ({
  animationSrc,
  fallbackImage,
  safariAnimationSrc,
}: {
  animationSrc: string
  fallbackImage: string
  safariAnimationSrc?: string
}) => {
  const [src, setSrc] = useState<string>(animationSrc)
  const [fallbackSrc, setFallbackSrc] = useState<string | StaticImageData>(fallbackImage)
  const [error, setError] = useState(false)
  const [show, setShow] = useState(false)
  const isProd = STAGE === 'production'

  useEffect(() => {
    setSrc(animationSrc)
    setFallbackSrc(fallbackImage)
    setShow(true)
  }, [animationSrc, fallbackImage])

  const handleNotFound = () => {
    if (!isProd) {
      setFallbackSrc(AssetMissingNonprod)
    } else {
      setFallbackSrc(NotFound)
    }
    setError(true)
  }

  if (!show) {
    return null
  }

  const image = (
    <Image
      alt=""
      src={fallbackSrc}
      onErrorCapture={() => handleNotFound()}
      fill
      style={{
        objectFit: 'contain',
      }}
      sizes="200px"
    />
  )

  if (safariAnimationSrc && !error) {
    return (
      <Image
        alt=""
        src={safariAnimationSrc}
        onErrorCapture={() => handleNotFound()}
        style={{
          objectFit: 'contain',
          width: '150%',
        }}
        width="200"
        height="200"
      />
    )
  }

  if (!error) {
    return (
      <video
        playsInline
        muted
        autoPlay
        loop
        onError={() => handleNotFound()}
        src={src}
        style={{
          width: '150%',
        }}
      >
        {image}
      </video>
    )
  }

  return image
}
